module.exports = __webpack_public_path__ + "static/media/person.519f42e8.svg";